module.exports = __webpack_public_path__ + "img/Uhrmacher.d03d4ed5.jpg";